import api from "./axiosConfig";
import { API_ENDPOINTS } from "./apiConfig";

export async function sendClientMessage(clientId: number, content: string | null) {
  const url = API_ENDPOINTS.adminClientMessage.replace("{id}", String(clientId));
  return api.post(url, { content });
}